import {defineMessages} from 'react-intl';

const SellMarketingMessage = defineMessages({
  ComparePriceTitle: {
    id: 'SellMarketing.ComparePrice.title',
    defaultMessage: 'Compare Prices'
  },
  ComparePriceContent: {
    id: 'SellMarketing.ComparePrice.content',
    defaultMessage: 'See what prices others have listed their tickets at so you can see how your listing stacks up.'
  },
  ComparePriceAlt: {
    id: 'SellMarketing.ComparePrice.alt',
    defaultMessage: 'An event listing with prices of other tickets'
  }
});

export default SellMarketingMessage;
